module.exports = __webpack_public_path__ + "static/img/int1.5725366b.jpg";